export default "__VITE_ASSET__Ysa62UMX__"